/*
 * Created on Thu Oct 12 2023 10:21:24 AM
 *
 * ***************************************************************************************
 * Copyright (c) AVPS Technologies Inc 2023 
 *
 * All Rights Reserved
 * Unpublished rights are reserved under the copyright laws of the United States.
 * The software contained in this media is proprietary to and embodies confidential
 * the technology of AVPS Technologies Inc. Possession, use, duplication or
 * dissemination of the software and media is authorized only pursuant to a valid
 * written license from AVPS Technologies Inc.
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * RESTRICTED RIGHTS LEGEND Use, duplication, or disclosure by the U.S. Government
 * is subject to restrictions as set forth in Subparagraph (c) (1) (ii) of DFARS
 * 252.227-7013 or in FAR 52.227-19, as applicable.
 ****************************************************************************************
 */
// courses
export const CREATE_COURSE = 'CREATE_COURSE';
export const UPDATE_COURSE = 'UPDATE_COURSE';
export const GET_USER_COURSE = 'GET_USER_COURSE';
export const GET_ALL_COURSES = 'GET_ALL_COURSES';
export const DELETE_COURSE = 'DELETE_COURSE';
export const GET_CURRICULUMS = 'GET_CURRICULUMS';

//user
export const GET_USER_EMAIL = 'GET_USER_EMAIL';
export const GET_USER_INFO = 'GET_USER_INFO';
export const GET_USER_INFO_EMAIL = 'GET_USER_INFO_EMAIL';

export const SIGNIN_SUCCESS = 'SIGNIN_SUCCESS';
export const SIGNIN_FAIL = 'SIGNIN_FAIL';
export const CLEAR_PENDING_AUTH = 'CLEAR_PENDING_AUTH';
export const REGISTER_SUCCESS = 'REGISTER_SUCCESS';
export const REGISTER_FAIL = 'REGISTER_FAIL';

export const UPDATE_STUDENT = 'UPDATE_STUDENT';
export const UPDATE_STUDENT_FAIL = 'UPDATE_STUDENT_FAIL';

export const SUBSCRIBED_SUCCESS = 'SUBSCRIBED_SUCCESS';
export const SUBSCRIBED_FAIL = 'SUBSCRIBED_FAIL';
export const PAYMENT_SUCCESS = 'PAYMENT_SUCCESS'
export const RETURN_URL_SUCCESS = 'RETURN_URL_SUCCESS';
export const PAYMENT_FAIL = 'PAYMENT_FAIL'

export const GET_EXAM_SUCCESS = 'GET_EXAM_SUCCESS';
export const GET_EXAM_FAILURE = 'GET_EXAM_FAILURE';
export const GET_ALL_ADMINS = 'GET_ALL_ADMINS';

//company from prefix
export const FETCH_COMPANY_DETAILS_SUCCESS = 'FETCH_COMPANY_DETAILS_SUCCESS';
export const FETCH_COMPANY_DETAILS_FAILURE = 'FETCH_COMPANY_DETAILS_FAILURE';

// store/action/types.js
export const CREATE_SUBDOMAIN_SUCCESS = 'CREATE_SUBDOMAIN_SUCCESS';
export const CREATE_SUBDOMAIN_FAILURE = 'CREATE_SUBDOMAIN_FAILURE';
export const SET_SELECTED_BRANCH = 'SET_SELECTED_BRANCH';
export const CLEAR_SELECTED_BRANCH = 'CLEAR_SELECTED_BRANCH';

// schedules
export const CREATE_SCHEDULE = 'CREATE_SCHEDULE';
export const GET_ALL_SCHEDULES = 'GET_ALL_SCHEDULES';
export const GET_SCHEDULE = 'GET_SCHEDULE';
export const UPDATE_SCHEDULE = 'UPDATE_SCHEDULE';
export const DELETE_SCHEDULE = 'DELETE_SCHEDULE';
export const DERIVE_END_DATE = 'DERIVE_END_DATE';


// course schedules 
export const CREATE_COURSE_SCHEDULE = 'CREATE_COURSE_SCHEDULE';
export const GET_ALL_COURSE_SCHEDULES = 'GET_ALL_COURSE_SCHEDULES';
export const RETRIEVE_COURSE_SCHEDULE = 'RETRIEVE_COURSE_SCHEDULE';
export const GET_COURSE_SCHEDULE = 'GET_COURSE_SCHEDULE';
export const UPDATE_COURSE_SCHEDULE = 'UPDATE_COURSE_SCHEDULE';
export const DELETE_COURSE_SCHEDULE = 'DELETE_COURSE_SCHEDULE';
export const ASSIGN_STUDENT_COURSE = 'ASSIGN_STUDENT_COURSE';
export const ASSIGN_STUDENT_LIST_COURSE = 'ASSIGN_STUDENT_LIST_COURSE';
export const REMOVE_COURSE_SCHEDULE_STUDENT = 'REMOVE_COURSE_SCHEDULE_STUDNET';
export const CREATE_CURRICULUM_SUCCESS = 'CREATE_CURRICULUM_SUCCESS';
export const CREATE_CURRICULUM_FAILURE = 'CREATE_CURRICULUM_FAILURE';
// resumes
export const UPLOAD_RESUME = 'UPLOAD_RESUME';
export const UPLOAD_RESUME_FAIL = 'UPLOAD_RESUME_FAIL';

// applicants
export const CREATE_APPLICANT = 'CREATE_APPLICANT';
export const CREATE_APPLICANT_FAIL = 'CREATE_APPLICANT_FAIL';

// export const AUTH_ERROR =                           'AUTH-ERROR';
export const LOGOUT = 'LOGOUT';
export const LOGOUT_START = 'LOGOUT_START';
// export const ACCOUNT_DELETED =                      'ACCOUNT_DELETED';
// export const INACTIVE_ACCOUNT =                     'INACTIVE_ACCOUNT';

export const ALERT_ACTIVE = 'ALERT_ACTIVE';
export const ALERT_INACTIVE = 'ALERT_INACTIVE';

// export const SEND_FORGOTTEN_PASSWORD_INIT =         'SEND_FORGOTTEN_PASSWORD_INIT';
// export const SEND_FORGOTTEN_PASSWORD =              'SEND_FORGOTTEN_PASSWORD';
// export const SEND_PASSWORD_RESET_REQUEST_INIT =     'SEND_PASSWORD_RESET_REQUEST_INIT';
export const SEND_PASSWORD_RESET_REQUEST = 'SEND_PASSWORD_RESET_REQUEST';
export const RESET_PASSWORD = 'RESET_PASSWORD';
export const CONFIRM_USER = 'CONFIRM_USER';
export const CONFIRM_INSTRUCTOR = 'CONFIRM_INSTRUCTOR';
export const SET_INSTRUCTOR_PASSWORD = 'SET_INSTRUCTOR_PASSWORD';
export const TOKEN_EXPIRED = 'TOKEN_EXPIRED';
export const VIDEO_UPLOAD_FAILURE = 'VIDEO_UPLOAD_FAILURE'
export const VIDEO_UPLOAD_SUCCESS = 'VIDEO_UPLOAD_SUCCESS'
export const DOCUMENT_UPLOAD_SUCCESS = 'DOCUMENT_UPLOAD_SUCCESS';
export const DOCUMENT_UPLOAD_FAILURE = 'DOCUMENT_UPLOAD_FAILURE';
export const DELETE_FILE_SUCCESS = 'DELETE_FILE_SUCCESS';
export const DELETE_FILE_FAILURE = 'DELETE_FILE_FAILURE';

export const GET_FILE_SUCCESS = 'GET_FILE_SUCCESS';
export const GET_FILE_FAILURE = 'GET_FILE_FAILURE';

export const IMAGE_UPLOAD_FAILURE = 'IMAGE_UPLOAD_FAILURE';
export const IMAGE_UPLOAD_SUCCESS = 'IMAGE_UPLOAD_SUCCESS';

export const GET_CONTENT_BY_ID = 'GET_CONTENT_BY_ID';
export const GET_INVOICES = 'GET_INVOICES';

export const GET_ALL_ACTIVE_COMPANYS = 'GET_ALL_ACTIVE_COMPANYS';
export const GET_ALL_DOMAINS = 'GET_ALL_DOMAINS';
export const GET_COMPANY_BY_PREFIX = 'GET_COMPANY_BY_PREFIX';
export const GET_COMPANY = 'GET_COMPANY';
export const GET_PRODUCT_CATEGORY = 'GET_PRODUCT_CATEGORY';
export const GET_PRODUCT_BY_ID = 'GET_PRODUCT_BY_ID';
export const GET_ALL_PRODUCTS = 'GET_ALL_PRODUCTS';
export const GET_SCHEDULED_PRODUCTS_BY_PRODUCT_CODE = 'GET_SCHEDULED PRODUCT_CODE';
export const GET_ALL_PRODUCT_CATEGORIES = 'GET_ALL_PRODUCT_CATEGORIES';
export const GET_VALID_PRODUCTS = 'GET_VALID_PRODUCTS';
export const GET_ALL_SCHEDULED_PRODUCTS = 'GET_ALL_SCHEDULED_PRODUCTS';

// for orders
export const GET_ORDER_BY_ID = 'GET_ORDER_BY_ID';
export const GET_ALL_ORDERS_BY_ACCOUNT_ID = 'GET_ALL_ORDERS_BY_ACCOUNT_ID';
export const GET_USER_SCHEDULED_PRODUCTS = 'GET_USER_SCHEDULED_PRODUCTS';
export const GET_ALL_ORDERS_BY_ACCOUNT_STATUS = 'GET_ALL_ORDERS_BY_ACCOUNT_STATUS';
export const GET_USER_BY_COMPANY_CODE_SUCCESS = 'GET_USER_BY_COMPANY_CODE_SUCCESS';
export const GET_USER_BY_COMPANY_CODE_FAIL = 'GET_USER_BY_COMPANY_CODE_FAIL';
export const GET_ALL_PRODUCT_BY_CATEGORY = 'GET_ALL_PRODUCT_BY_CATEGORY';
export const SEARCH_PRODUCTS = 'SEARCH_PRODUCTS';
export const CREATE_PRODUCT_SCHEDULE = "CREATE_PRODUCT_SCHEDULE";
export const CREATE_TIME_SCHEDULE = "CREATE_TIME_SCHEDULE";
export const SET_APPLICANT_DATA = "SET_APPLICANT_DATA";
export const FETCH_APPLICANT_SUCCESS = "FETCH_APPLICANT_SUCCESS";
export const FETCH_APPLICANT_FAILURE = "FETCH_APPLICANT_FAILURE";
export const SET_ADMIN_DATA = "SET_ADMIN_DATA";

export const CREATE_DISCOUNT = 'CREATE_DISCOUNT';
export const CREATE_DISCOUNT_SUCCESS = 'CREATE_DISCOUNT_SUCCESS';
export const CREATE_DISCOUNT_FAILURE = 'CREATE_DISCOUNT_FAILURE';

export const UPDATE_DISCOUNT = 'UPDATE_DISCOUNT';
export const UPDATE_DISCOUNT_SUCCESS = 'UPDATE_DISCOUNT_SUCCESS';
export const UPDATE_DISCOUNT_FAILURE = 'UPDATE_DISCOUNT_FAILURE';

export const GET_DISCOUNT = 'GET_DISCOUNT';
export const GET_DISCOUNT_SUCCESS = 'GET_DISCOUNT_SUCCESS';
export const GET_DISCOUNT_FAILURE = 'GET_DISCOUNT_FAILURE';

export const GET_DISCOUNT_WITH_COMPANY = 'GET_DISCOUNT_WITH_COMPANY';
export const GET_DISCOUNT_WITH_COMPANY_SUCCESS = 'GET_DISCOUNT_WITH_COMPANY_SUCCESS';
export const GET_DISCOUNT_WITH_COMPANY_FAILURE = 'GET_DISCOUNT_WITH_COMPANY_FAILURE';

export const FIND_DISCOUNTS = 'FIND_DISCOUNTS';
export const FIND_DISCOUNTS_SUCCESS = 'FIND_DISCOUNTS_SUCCESS';
export const FIND_DISCOUNTS_FAILURE = 'FIND_DISCOUNTS_FAILURE';

export const FIND_DISCOUNTS_BY_IDS = 'FIND_DISCOUNTS_BY_IDS';
export const FIND_DISCOUNTS_BY_IDS_SUCCESS = 'FIND_DISCOUNTS_BY_IDS_SUCCESS';
export const FIND_DISCOUNTS_BY_IDS_FAILURE = 'FIND_DISCOUNTS_BY_IDS_FAILURE';

export const DELETE_DISCOUNT = 'DELETE_DISCOUNT';
export const DELETE_DISCOUNT_SUCCESS = 'DELETE_DISCOUNT_SUCCESS';
export const DELETE_DISCOUNT_FAILURE = 'DELETE_DISCOUNT_FAILURE';

export const REMOVE_DISCOUNT = 'REMOVE_DISCOUNT';
export const REMOVE_DISCOUNT_SUCCESS = 'REMOVE_DISCOUNT_SUCCESS';
export const REMOVE_DISCOUNT_FAILURE = 'REMOVE_DISCOUNT_FAILURE';
export const FIND_ELIGIBLE_DISCOUNTS = 'FIND_ELIGIBLE_DISCOUNTS';

export const GET_QUOTE = 'GET_QUOTE';
export const UPDATE_QUOTE = 'UPDATE_QUOTE';
export const GET_QUOTE_BY_ID = 'GET_QUOTE_BY_ID';
export const GET_QUOTE_BY_COMPANY = 'GET_QUOTE_BY_COMPANY';

export const CREATE_INVOICE = 'CREATE_INVOICE';
export const UPDATE_INVOICE = 'UPDATE_INVOICE';
export const GET_INVOICE_BY_ID = 'GET_INVOICE_BY_ID';
export const GET_INVOICE_BY_ID_AND_COMPANY = 'GET_INVOICE_BY_ID_AND_COMPANY';
export const FIND_INVOICES_BY_CRITERIA = 'FIND_INVOICES_BY_CRITERIA';
export const FIND_SUBSCRIPTION_BILLS = 'FIND_SUBSCRIPTION_BILLS';
export const DELETE_INVOICE = 'DELETE_INVOICE';
export const REMOVE_INVOICE = 'REMOVE_INVOICE';
export const SEND_OTP_SUCCESS = "SEND_OTP_SUCCESS";
export const SEND_OTP_FAIL = "SEND_OTP_FAIL";

export const GET_RESERVATION_SLOTS_SUCCESS = "GET_RESERVATION_SLOTS_SUCCESS";
export const GET_RESERVATION_SLOTS_FAIL = "GET_RESERVATION_SLOTS_FAIL";
export const GET_ALL_SUBSCRIPTION_PLANS = "GET_ALL_SUBSCRIPTION_PLANS";
export const AI_REGISTER_SUCCESS = 'REGISTER_SUCCESS';
export const AI_REGISTER_FAIL = 'REGISTER_FAIL';
export const GET_ME_SUCCESS = 'GET_ME_SUCCESS';
export const AI_LOGIN_SUCCESS = 'AI_LOGIN_SUCCESS';

export const CREATE_ORDERS = 'CREATE_ORDERS';
export const ORDER_REVERSAL = "ORDER_REVERSAL";
export const UPDATE_ORDER = "UPDATE_ORDER";
export const GET_MAX_CAPACITY = 'GET_MAX_CAPACITY';
